import { Component, OnInit } from '@angular/core';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { UserService } from '../../shared/user.service';

@Component({
  selector: 'app-priority-issue',
  templateUrl: './priority-issue.component.html',
  styleUrls: ['./priority-issue.component.css']
})
export class PriorityIssueComponent implements OnInit {

  constructor(private userService: UserService,private errorHandler: ErrorHandler) { }

  ngOnInit() {
    this.PriorityIssue();
  }

  PriorityIssue = function(){
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.priorityIssue()
    .subscribe((data:any)=>{
      this.PriorityIssue = data;
      document.getElementById('loader-spinner').style.display = "none";
    },(error)=>{
      document.getElementById('loader-spinner').style.display = "none";
      this.errorHandler.HandlerError(error);
    });

}

}



// WEBPACK FOOTER //
// ./src/app/reports/priority-issue/priority-issue.component.ts